import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import {
  Wrapper,
} from './styles';
import {
  useFlightSearchStore,
} from '../../store/flightSearch/flightSearchStore';
import FlightDetails from "./FlightDetails";
import {useStore} from "../../store/global/appStore";


type Props = {
  results?: FlightAggregateResultItem,
  onBookingRedirect: (arg: AirlineResultItem[]) => void
  selectedFlights: AirlineResultItem[],
  onFlightSelect: (arg: AirlineResultItem[]) => void
  cheapestFares: {
    cheapestDeparture: number | null,
    cheapestReturn: number | null
  }
}
function AvailableFlights({
                            results, onBookingRedirect,
                            selectedFlights, onFlightSelect, cheapestFares
                          }: Props) {
  const {
    formData,
  } = useFlightSearchStore();
  const { airports } = useStore();

  const resultLists = useMemo<FlightResultItem[]>(() => (results ? results.ResultList : []), [results]);
  const departureFlights: AirlineResultItem[] = resultLists[0]?.ResultList || [];
  const [returnFlights, setReturnFlights] = useState<AirlineResultItem[]>(resultLists[1]?.ResultList || []);
  const cheapestDeparture = cheapestFares?.cheapestDeparture;
  const cheapestReturn = cheapestFares?.cheapestReturn;
  const isOneWay = formData.tripType === 'one_way';

  const getFastestDuration = (flights: AirlineResultItem[]) => {
    if (!flights || flights.length === 0) return null;
    let min = Infinity;
    flights.forEach((f) => {
      if (!f.FlightDetails || f.FlightDetails.length === 0) return;
      const dep = moment(f.FlightDetails[0].DepartureDate);
      const arr = moment(f.FlightDetails[f.FlightDetails.length - 1].ArrivalDate);
      const diff = arr.diff(dep, 'minutes');
      if (diff < min) min = diff;
    });
    return min === Infinity ? null : min;
  };

  const getEarliestTime = (flights: AirlineResultItem[]) => {
    if (!flights || flights.length === 0) return null;
    let min = Infinity;
    flights.forEach((f) => {
      if (!f.FlightDetails || f.FlightDetails.length === 0) return;
      const dep = moment(f.FlightDetails[0].DepartureDate).valueOf();
      if (dep < min) min = dep;
    });
    return min === Infinity ? null : min;
  };

  const fastestDepartureDuration = useMemo(() => getFastestDuration(departureFlights), [departureFlights]);
  const earliestDepartureTime = useMemo(() => getEarliestTime(departureFlights), [departureFlights]);
  const fastestReturnDuration = useMemo(() => getFastestDuration(returnFlights), [returnFlights]);
  const earliestReturnTime = useMemo(() => getEarliestTime(returnFlights), [returnFlights]);

  const handleSelectFlight = (result: AirlineResultItem[]) => {
    if(isOneWay) {
      onBookingRedirect(result);
      return;
    }

    if (!formData.isDomestic) {
        onFlightSelect(result);
        onBookingRedirect(result);
        return;
    }

    if (selectedFlights.length === 0) {
      onFlightSelect(result);
    } else {
      let selections = [...selectedFlights];
      selections[1] = result[0];
      onFlightSelect(selections);
      onBookingRedirect(selections);
    }
  };

  useEffect(() => {
    setReturnFlights(resultLists[1]?.ResultList || []);
  }, [resultLists]);

  return (
      <Wrapper>
        {formData.isDomestic ? (
                <>
                  {selectedFlights.length === 0 && departureFlights.map((result, index) => (
                      <FlightDetails
                          key={index}
                          index={index}
                          result={result}
                          onlyDepartureSelected={!isOneWay}
                          handleSelectFlight={handleSelectFlight}
                          cheapestFare={cheapestDeparture}
                          fastestDuration={fastestDepartureDuration}
                          earliestTime={earliestDepartureTime}
                          airports={airports}
                      />
                  ))}

                  {selectedFlights.length > 0 && returnFlights.map((result, index) => (
                      <FlightDetails
                          key={index}
                          index={index}
                          result={result}
                          onlyDepartureSelected={false}
                          handleSelectFlight={handleSelectFlight}
                          cheapestFare={cheapestReturn}
                          fastestDuration={fastestReturnDuration}
                          earliestTime={earliestReturnTime}
                          airports={airports}
                      />
                  ))}
                </>
            )
            : (
               <>
                 {departureFlights.map((result, index) => (
                       <FlightDetails
                           key={index}
                           index={index}
                           result={result}
                           onlyDepartureSelected={false}
                           handleSelectFlight={handleSelectFlight}
                           cheapestFare={cheapestDeparture}
                           fastestDuration={fastestDepartureDuration}
                           earliestTime={earliestDepartureTime}
                           airports={airports}
                       />
                 ))}
               </>
            )}

      </Wrapper>

  );
}

AvailableFlights.defaultProps = {
  loading: false,
  error: undefined,
  results: undefined,
};
export default AvailableFlights;
